export default __webpack_public_path__ + "static/media/healthcare3.8fea02e6.png";